// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__11Ntk","boxTitle":"Qualiphy_boxTitle__1U5tr","box":"Qualiphy_box__3IKk8","toggleWrap":"Qualiphy_toggleWrap__26-l4"};